import { useEffect, useState } from "react";

const getMatch = () =>
  typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia("(min-width: 768px)").matches
    : false;

export default function useDesktop() {
  const [isDesktop, setIsDesktop] = useState(getMatch);

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 768px)");
    setIsDesktop(mq.matches);
    const listener = (e) => setIsDesktop(e.matches);
    mq.addEventListener("change", listener);
    return () => mq.removeEventListener("change", listener);
  }, []);

  return isDesktop;
}
